import React from 'react'

import { usePopup } from '../../lib/usePopup'
import Menu from '../Menu'
import MenuItem from '../MenuItem'
import Popup from '../Popup'

interface SubmenuProps {
  label: string
  before?: React.ReactNode
  after?: React.ReactNode
  disabled?: boolean
}

function Submenu({ children, label, before, after, disabled }: React.PropsWithChildren<SubmenuProps>) {
  const { isOpened, nodeId, refs, context, floatingStyles, getFloatingProps, getReferenceProps } = usePopup({
    offset: 4,
    placement: 'right-start',
    ariaRole: 'menu',
    disabled,
  })

  return (
    <>
      <MenuItem ref={refs.setReference} before={before} after={after} {...getReferenceProps({ tabIndex: 0, disabled })}>
        {label}
      </MenuItem>

      <Popup
        ref={refs.setFloating}
        nodeId={nodeId}
        opened={isOpened}
        context={context}
        style={floatingStyles}
        {...getFloatingProps()}
      >
        <Menu>{children}</Menu>
      </Popup>
    </>
  )
}

export default Submenu
